import React from "react";
import HomePage from "../components/homePageComponents/HomePage";
import Footer from "../footer";


function FinalHomePage() {
    return(
        <div>
            <HomePage />
            <Footer />
        </div>
    )
}
export default FinalHomePage;